module.exports = __webpack_public_path__ + "static/media/PassengerCooke.ab6685cb.png";